// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'XS' | 'S' | 'M' | 'L' | 'XL' | number, // NOTE: イレギュラーサイズはそのまま数値を渡すようにする
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
/** @deprecated src/components/iconに定義されている新しいアイコンに置き換えます。
 *
 * 特段の理由がない場合、新規実装でこちらは使用しないでください。 */
const SvgInfo = ({ size = 'S', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    height={
      size === 'XS'
        ? '8px'
        : size === 'S'
        ? '16px'
        : size === 'M'
        ? '24px'
        : size === 'L'
        ? '32px'
        : size === 'XL'
        ? '40px'
        : size
    }
    fill={props.color ?? 'currentColor'}
    viewBox="0 0 16 16"
    {...props}
  >
    <circle cx={8} cy={8} r={8} />
    <path
      fill="#fff"
      d="M7.144 12.732h1.764v-6.72H7.144zm.888-7.8c.6 0 1.02-.384 1.02-.972 0-.576-.42-.96-1.02-.96C7.42 3 7 3.384 7 3.96c0 .588.42.972 1.032.972"
    />
  </svg>
)
export default SvgInfo
